import { render, staticRenderFns } from "./addDefaultTemplate.vue?vue&type=template&id=38f894ec&lang=pug"
import script from "./addDefaultTemplate.vue?vue&type=script&lang=js"
export * from "./addDefaultTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports